import FileExplorer from "../FileExplorer/FileExplorer";
import Modal from "./Modal";

export default function MediaModal({ files, data, callback, closeModal, onSubmit, onDelete, onCancel, multiple }) {
    return (
        <Modal closeCallback={closeModal}>
            <div className="modal__preview">
                {data.MediaType==="1" && !multiple &&
                    <img src={"/assets/images/"+data.Source} alt={data.Source} id="editMedia__image" className="modal__image" />
                }
                {data.MediaType==="1" && multiple &&
                    data.Source?.filter(path=>!path.endsWith("/")&&path!=="")?.map(path=><img src={"/assets/images/"+path} alt={path} id="editMedia__image" className="modal__image" />)
                }
                {data.MediaType==="2" &&
                    <img src={"https://img.youtube.com/vi/"+data.Source+"/mqdefault.jpg"} alt={data.Source} id="editMedia__image" className="modal__image" />
                }
            </div>
            <div className="modal__options">
                <label htmlFor="editMedia__mediaType">Type:</label>
                <select name="mediaType" id="editMedia__mediaType" value={data.MediaType} onChange={(e)=>{callback({"MediaType":e.target.value})}}>
                    <option value="1">Image</option>
                    <option value="2">Youtube Embed</option>
                </select>
                <br/>
                {data.MediaType==="1" &&
                    <FileExplorer
                        files={files}
                        s={data.Source}
                        callback={(e)=>{callback({"Source":e})}}
                        multiple={multiple}
                    />
                }
                {data.MediaType==="2" &&
                    <>
                        <br/>
                        <label htmlFor="editMedia__mediaType">Video ID:</label>
                        <input type="text" name="source" value={data.Source} onChange={e=>callback({"Source":e.target.value})} />
                        <br/>
                    </>
                }
                <br/>
                <button className="modal__button" onClick={onSubmit} disabled={data.Source.length===0}>Submit</button>
                {onDelete && <button className="modal__button" onClick={onDelete}>Delete</button>}
                <button className="modal__button" onClick={onCancel} style={{"float":"right"}}>Cancel</button>
            </div>
        </Modal>
    )
}